import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderDe = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Rate mal, wo das Geld ist."
                highlights={[
                    { word: 'Rate' },
                    { word: 'mal,' },
                    { word: 'wo' },
                    { word: 'das' },
                    { word: 'Geld' },
                    { word: 'ist.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['mal,']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Drei Versuche!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
